import { render, staticRenderFns } from "./ContentDisplayClosed.vue?vue&type=template&id=5efe83f6&scoped=true&"
import script from "./ContentDisplayClosed.vue?vue&type=script&lang=ts&"
export * from "./ContentDisplayClosed.vue?vue&type=script&lang=ts&"
import style0 from "./ContentDisplayClosed.vue?vue&type=style&index=0&id=5efe83f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe83f6",
  null
  
)

export default component.exports